export default { sha: '5ea8e7c2e2ad38abd3168d5e8597b50f983fc9f7', buildNumber: 'undefined' }
